export const CHARGE_DUPLICATION_CONFIRMATION_MESSAGE =
  '請求明細が作成済み、または請求明細が手入力されているため、一部の請求明細の金額が2重になります。請求明細を確認してください。'

export const isChargeDuplicationConfirmationRequired = error => {
  const errors = error && error.graphQLErrors
    ? error.graphQLErrors
    : (Array.isArray(error) ? error : [error])
  return errors.some(item =>
    item &&
    item.code === 'CONFIRMATION_REQUIRED' &&
    item.message === 'BOOKING_CHARGE_DUPLICATION_CONFIRMATION_REQUIRED',
  )
}

export const showChargeDuplicationConfirmation = ({ confirm, router, bookingId, retry }) => {
  confirm({
    message: CHARGE_DUPLICATION_CONFIRMATION_MESSAGE,
    cancelText: '戻る（変更しない）',
    okText: '変更して請求明細画面へ移動',
    ok: async () => {
      await retry()
      await router.push({
        path: '/reservation/contract-detail',
        query: {
          id: bookingId,
          tab: 'billing-statement',
        },
      })
    },
  })
}
